module.exports = __webpack_public_path__ + "img/Picture21.9e8a67c4.png";